import type { FC } from 'react';

import Info from '@crehana/compass.icons.outline/Info';
import { cn } from '@crehana/compass.ui/utils';

import { StudioCourseConfigStateEnum } from '@/shared/types/graphql/globals.v5';

import useTeamCoursesTranslation from '../../../hooks/useTeamCoursesTranslation';
import type { TInformation } from '../../../types';
import Divider from './Divider';

const Information: FC<TInformation> = ({
  title,
  teacherName,
  duration,
  labelTrack,
  isVisibleTeacherName,
  isRequired,
  visibilityState,
}) => {
  const { t } = useTeamCoursesTranslation();

  const isHiddenCourse = visibilityState === StudioCourseConfigStateEnum.HIDDEN;

  return (
    <>
      {isHiddenCourse ? (
        <div className="tw-w-full sm:tw-my-auto">
          <div className="tw-flex tw-flex-col tw-w-full">
            <p className="tw-line-clamp-1 tw-font-subtitle5 tw-mb-0.4 tw-text-neutral-light-800 dark:tw-text-neutral-light-100">
              {t('COURSE_VISIBILITY_STATE_HIDDEN_TITLE')}
            </p>
            <div className="tw-w-fit tw-flex tw-items-center tw-gap-0.4 tw-px-0.8 tw-py-0.4 tw-rounded-0.4 tw-bg-on-hold-400">
              <Info size={16} className="tw-text-neutral-light-100" />
              <p className="tw-font-caption tw-text-neutral-light-100">
                {t('COURSE_VISIBILITY_STATE_HIDDEN_SUBTITLE')}
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="tw-w-full tw-mb-0.8">
          <div className="tw-flex tw-items-center tw-justify-between">
            <p className="tw-line-clamp-2 tw-block tw-font-subtitle5 tw-mb-0.4 tw-text-neutral-light-800 dark:tw-text-neutral-light-100">
              {title}
            </p>
          </div>

          <div className="tw-mb-1 tw-flex tw-items-center tw-w-full tw-text-neutral-light-700 dark:tw-text-neutral-dark-400 tw-font-body5">
            <div
              className={cn('tw-flex tw-flex-row tw-items-center', {
                'tw-hidden': isVisibleTeacherName,
              })}
            >
              <span className="tw-line-clamp-1 tw-block">{teacherName}</span>
              {(duration || isRequired) && <Divider />}
            </div>
            {isRequired && (
              <>
                <span className="tw-flex-shrink-0 tw-text-primary-light-500">
                  {t('TAG_REQUIRED')}
                </span>
                {duration && <Divider />}
              </>
            )}
            {duration && <span className="tw-flex-shrink-0">{duration}</span>}
          </div>
          <span className="tw-font-label1  tw-text-neutral-light-600 tw-uppercase">
            {labelTrack}
          </span>
        </div>
      )}
    </>
  );
};

export default Information;
